/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_heat_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online heatmap maker. Paste a matrix of values with row and column labels to get a colour-coded heatmap.`)
};

const es_heat_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador gratuito de mapas de calor online. Pega una matriz de valores con etiquetas de fila y columna para obtener un mapa de calor codificado por color.`)
};

const de_heat_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Heatmap-Ersteller. Fügen Sie eine Matrix von Werten mit Zeilen- und Spaltenbezeichnungen ein, um eine farbcodierte Heatmap zu erhalten.`)
};

const nl_heat_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online heatmapmaker. Plak een matrix van waarden met rij- en kolomlabels om een kleurgecodeerde heatmap te krijgen.`)
};

const fr_heat_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur gratuit de carte de chaleur en ligne. Collez une matrice de valeurs avec des étiquettes de ligne et de colonne pour obtenir une carte de chaleur codée par couleur.`)
};

const it_heat_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore gratuito di mappe di calore online. Incolla una matrice di valori con etichette di riga e colonna per ottenere una mappa di calore codificata a colori.`)
};

const pt_br2_heat_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador gratuito online de mapa de calor. Cole uma matriz de valores com rótulos de linha e coluna para obter um mapa de calor codificado por cores.`)
};

const pt_heat_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador gratuito de mapas de calor online. Cole uma matriz de valores com rótulos de linha e coluna para obter um mapa de calor codificado por cor.`)
};

const ja_heat_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンラインヒートマップ作成ツール。行と列のラベル付きの値の行列を貼り付けると、色分けされたヒートマップが得られます。`)
};

const zh_heat_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线热力图制作工具。粘贴带行列标签的数值矩阵即可获得颜色编码的热力图。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const heat_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.heat_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("heat_meta_description", locale)
	if (locale === "en") return en_heat_meta_description(inputs)
	if (locale === "es") return es_heat_meta_description(inputs)
	if (locale === "de") return de_heat_meta_description(inputs)
	if (locale === "nl") return nl_heat_meta_description(inputs)
	if (locale === "fr") return fr_heat_meta_description(inputs)
	if (locale === "it") return it_heat_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_heat_meta_description(inputs)
	if (locale === "pt") return pt_heat_meta_description(inputs)
	if (locale === "ja") return ja_heat_meta_description(inputs)
	return zh_heat_meta_description(inputs)
};